import React from 'react';
import './Results.css';

const results = [
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 17l5-5 4 4 9-9" strokeLinecap="round" strokeLinejoin="round" /></svg>,
    title: 'Higher Revenue',
    description: 'Significant revenue growth through strategic planning and disciplined execution',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M13 10V3L4 14h7v7l9-11h-7z" strokeLinecap="round" strokeLinejoin="round" /></svg>,
    title: 'Improved Productivity',
    description: 'Streamlined operations and processes that boost team efficiency company-wide',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M4 6h16M4 10h16M4 14h10M4 18h7" strokeLinecap="round" /></svg>,
    title: 'Streamlined Operations',
    description: 'Optimized workflows and reduced inefficiencies across the entire organization',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="9" /><path d="M12 8v4l3 3" strokeLinecap="round" /></svg>,
    title: 'Faster Decisions',
    description: 'Clear strategic framework enables faster, better-informed decisions at every level',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>,
    title: 'Long-Term Clarity',
    description: 'A clear roadmap for sustainable growth and enduring competitive positioning',
  },
];

const Results = () => (
  <section id="results" className="sec results-section">
    <div className="w">
      <div className="rv">
        <div className="eye">Outcomes</div>
        <h2 className="sh">Results We <span>Deliver</span></h2>
        <p className="sl">Measurable outcomes that drive your business forward and create lasting competitive advantage.</p>
      </div>
      <div className="rsg">
        {results.map((result, index) => (
          <div className={`rsc rv d${index + 1}`} key={result.title}>
            <div className="rsiw">{result.icon}</div>
            <div className="rst">{result.title}</div>
            <div className="rsd">{result.description}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Results;
